import { FRAME_MS } from "odyssey-shared";
import { COPY_SPAN_FRAMES } from "./burst.ts";

/**
 * An emoji's life (ADR-114's amendment of 2026-10-09, points 1 and 4): its copies pop out at its first frame and the last
 * is gone after `COPY_SPAN_FRAMES` (`burst.ts`), when the emoji ends; under reduced motion the still emoji drawn in their
 * place lives as long. Pixel art never eases, so time is counted in whole 40 ms frames, as CSS `steps(n)` does on the
 * DOM.
 */

/**
 * An emoji's whole life in frames: its copies' span.
 */
export const EMOJI_FRAMES = COPY_SPAN_FRAMES;

/**
 * An emoji's whole life in ms, 1.92 seconds.
 */
export const EMOJI_LIFE_MS = EMOJI_FRAMES * FRAME_MS;

/**
 * The whole frames since an emoji started.
 *
 * @param elapsedMs Scene time since its first frame; a time before it counts as its first frame.
 * @returns The frame, from 0.
 * @example
 * emojiFrame(85);
 * // 2
 */
export function emojiFrame(elapsedMs: number): number {
  return Math.floor(Math.max(0, elapsedMs) / FRAME_MS);
}

/**
 * Whether an emoji still lives a time after it started.
 *
 * @param elapsedMs Scene time since its first frame.
 * @returns True through its last frame.
 */
export function emojiLives(elapsedMs: number): boolean {
  return emojiFrame(elapsedMs) < EMOJI_FRAMES;
}
